module.exports = __webpack_public_path__ + "img/azerbaijan.5eee4f6e.svg";